import React from 'react';
import BreakpointProvider from '../BreakpointProvider';
import DigitalDataProvider, { DD_DISABLE_SWATCH_HOVER, DD_HYPERLINK_DESC, DD_MODEL_IMAGERY_TEST } from '../DigitalDataProvider';

const PropTypes = require('prop-types');

const CategoryPageContext = ({
  children,
}) => (
  <BreakpointProvider>
    <DigitalDataProvider
      keys={[
        DD_DISABLE_SWATCH_HOVER,
        DD_HYPERLINK_DESC,
        DD_MODEL_IMAGERY_TEST,
      ]}
    >
      {children}
    </DigitalDataProvider>
  </BreakpointProvider>
);
CategoryPageContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CategoryPageContext;
